"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndoorOutdoorSwitch = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const booleans_1 = require("../../../const/booleans");
const hooks_1 = require("../../../store/hooks");
const mapSlice_1 = require("../../../store/mapSlice");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const FilterInfoPopup_1 = require("./FilterInfoPopup");
const S = __importStar(require("./SessionFilters.style"));
const IndoorOutdoorSwitch = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isIndoor, updateIndoorFilters, setFilter } = (0, mapParamsHandler_1.useMapParams)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const isIndoorParameterInUrl = isIndoor === booleans_1.TRUE;
    const handleIndoorClick = () => {
        updateIndoorFilters(booleans_1.TRUE);
        dispatch((0, mapSlice_1.setFetchingData)(true));
    };
    const handleOutdoorClick = () => {
        setFilter(mapParamsHandler_1.UrlParamsTypes.isIndoor, booleans_1.FALSE);
        dispatch((0, mapSlice_1.setFetchingData)(true));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.IndoorToggleHeading, null, t("filters.placementOfStations")),
        react_1.default.createElement(S.SingleFilterWrapper, { "$noMarginTop": true },
            react_1.default.createElement(S.IndoorFilterWrapper, null,
                react_1.default.createElement(S.IndoorToggleWrapper, { "$isIndoor": isIndoorParameterInUrl },
                    react_1.default.createElement(S.IndoorTab, { "$isActive": !isIndoorParameterInUrl, "$isIndoor": isIndoorParameterInUrl, onClick: handleOutdoorClick }, t("filters.outdoor")),
                    react_1.default.createElement(S.IndoorTab, { "$isActive": isIndoorParameterInUrl, "$isIndoor": isIndoorParameterInUrl, onClick: handleIndoorClick }, t("filters.indoor"))),
                isIndoorParameterInUrl && (react_1.default.createElement(S.IndoorToggleInfoWrapper, null,
                    react_1.default.createElement(S.IndoorToggleInfoText, null, t("filters.indoorMapInfo"))))),
            react_1.default.createElement(FilterInfoPopup_1.FilterInfoPopup, { filterTranslationLabel: "filters.indoorInfo" }))));
};
exports.IndoorOutdoorSwitch = IndoorOutdoorSwitch;
